import { Component, Input, OnInit, AfterContentInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-cx-header-tooltip',
  templateUrl: './cx-header-tooltip.component.html',
  styleUrls: ['./cx-header-tooltip.component.scss']
})
export class CxHeaderTooltipComponent implements OnInit, AfterContentInit {
  // Public props
  public isOpen = false;

  // Private props
  public thisElementClicked = false;

  // Inputs
  @Input() loggedUser: string;

  // Outputs
  constructor() { }

  @HostListener('click', ['$event'])
  private onLocalClick(event: Event): void  {
    this.thisElementClicked = true;
  }

  @HostListener('document:click', ['$event'])
  private onClick(event: Event): void  {
    if (!this.thisElementClicked) {
      this.focusOut();
    }
    this.thisElementClicked = false;
  }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void { }

  public openMenu(): void {
    this.isOpen = !this.isOpen;
  }

  private focusOut(): void  {
    this.isOpen = false;
  }
}
